// extracted by mini-css-extract-plugin
module.exports = {"BannerContainer":"style_BannerContainer__3yRvf","CompanyBanner":"style_CompanyBanner__3SjV4","BannerItem":"style_BannerItem__3ZV5F","BannerActive":"style_BannerActive__3fCnz"};